import { render } from "./ReserveInfoDetail_client.vue?vue&type=template&id=e6d58e7c&scoped=true"
import script from "./ReserveInfoDetail_client.vue?vue&type=script&lang=js"
export * from "./ReserveInfoDetail_client.vue?vue&type=script&lang=js"

import "./ReserveInfoDetail_client.vue?vue&type=style&index=0&id=e6d58e7c&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d58e7c"]])

export default __exports__